import React from "react";

// A very faint, large echo of the SEUTRADE globe seal used as a background
// brand watermark behind heroes and portal dashboards. Purely decorative:
// absolutely positioned, non-interactive, and low-opacity so it never fights
// with foreground content. Size + opacity are tunable via props.
export const SealWatermark = ({ size = 620, opacity = 0.06, className = "", fixed = false }) => (
  <div
    aria-hidden="true"
    data-testid="seal-watermark"
    className={`stf-wm ${fixed ? "stf-wm-fixed" : ""} ${className}`}
    style={{ width: size, height: size, opacity }}
  >
    <div className="stf-wm-ball" />
    <div className="stf-wm-grid" />
    <div className="stf-wm-edge" />

    <style>{`
      .stf-wm{ position:absolute; top:50%; left:50%; transform:translate(-50%,-50%);
        pointer-events:none; z-index:0; border-radius:50%; }
      .stf-wm-fixed{ position:fixed; top:42%; }
      .stf-wm-ball{ position:absolute; inset:0; border-radius:50%;
        background: radial-gradient(circle at 38% 32%, #C9A03A 0%, #8a6608 42%, #3f2e07 72%, transparent 100%); }
      .stf-wm-grid{ position:absolute; inset:5%; border-radius:50%; opacity:.55;
        -webkit-mask: radial-gradient(circle at 50% 50%, #000 0 72%, transparent 90%);
                mask: radial-gradient(circle at 50% 50%, #000 0 72%, transparent 90%);
        background:
          repeating-linear-gradient(90deg, transparent 0 46px, rgba(255,240,190,.35) 46px 47px),
          repeating-linear-gradient(0deg, transparent 0 36px, rgba(255,240,190,.22) 36px 37px); }
      .stf-wm-edge{ position:absolute; inset:0; border-radius:50%;
        box-shadow: inset 0 0 70px 24px rgba(0,0,0,.6);
        border:2px solid rgba(200,160,60,.4); }
    `}</style>
  </div>
);

export default SealWatermark;
